export default "__VITE_ASSET__CsfimUp___"